import { createRef } from 'react';
import { push } from 'redux-little-router';
import { connect } from 'react-redux';
import { compose, lifecycle, renderComponent, withProps } from 'recompose';

export const Redirect = compose(
  connect(null, { push }),
  lifecycle({
    componentDidMount() {
      this.props.push(this.props.to);
    },
  }),
)(() => null);

export const redirectTo = to => renderComponent(withProps({ to })(Redirect));

export const scrollToOpenCard = ({
  behavior = 'smooth',
  block = 'start',
  offsetTop = -10,
} = {}) => compose(
  withProps(() => ({ innerRef: createRef() })),
  lifecycle({
    componentDidUpdate(prevProps) {
      try {
        const ref = this.props.innerRef.current;
        if (this.props.isOpen && !prevProps.isOpen && ref) {
          const el = document.createElement('div');
          el.setAttribute('style', `position: absolute; top: ${offsetTop}px;`);

          ref.setAttribute('style', 'position: relative;');
          ref.insertBefore(el, ref.firstChild);

          el.scrollIntoView({
            behavior,
            block,
          });

          ref.removeChild(el);
        }
      } catch (e) {
        console.log('fail to scroll');
      }
    },
  }),
);



// WEBPACK FOOTER //
// ./src/api/utils/react-utils.js